export default __webpack_public_path__ + "static/media/eccentric-grinder.58be1e46.svg";